﻿'use strict';

angular.module('ntmApp').factory('DraggingToResourcePoolActions', [function () {

    function DraggingToResourcePoolActions(draggingActions) {

            var self = this;

            self.onStartDragging = function (event) {
                
                draggingActions.forEach(function (draggingAction) {
                    draggingAction.onStartDragging(event);
                });

                return self;
            };

            self.onEndDragging = function (event) {

                draggingActions.forEach(function (draggingAction) {
                    draggingAction.onEndDragging(event);
                });

                return self;
            };

            self.isDragging = function () {
                return draggingActions.some(function (draggingAction) {
                    return draggingAction.DraggingObject.isDraggingActionActive();
                });
            };

            function initialize() {
                self.DraggingType = "DRAG_TO_RESOURCE_POOL";
            }

            initialize();

        }

    return (DraggingToResourcePoolActions);

    }]);